import {useGetPatientProtocols} from '@/modules/patients/api/use-get-patient-protocols'
import {useGetPatientTherapies} from '@/modules/patients/api/use-get-patient-therapies'
import {AddParameterDialogNew} from '@/modules/patients/components/patient-details/therapy/dialogs/add-parameter-dialog-new'
import {PatientTherapySequence} from '@cypro/engine/schema'

export function RevisePrescriptionDialog({sequence}: {sequence: PatientTherapySequence}) {
  const [therapies] = useGetPatientTherapies(sequence.patientId)
  const [patientProtocols] = useGetPatientProtocols(sequence.patientId)
  const therapy = therapies?.find(t => t.id === sequence.id)

  if (!therapy) return null

  return (
    <AddParameterDialogNew
      patientProtocols={patientProtocols}
      patientId={sequence.patientId}
      existing={therapy}
    />
  )
}
